import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

import isNil from 'lodash/isNil'

import { Head, IEditableTableHead } from './head'
import TableResult from 'components/layout/tableResult'
import ItemCreator from './itemCreator'
import { IData } from 'components/layout/table'
import EditableTableRow, { SaveMode } from './editableTableRow'

import tableResultConfig from './tableResult.config'

export interface IEditableTableConfig {
  dataSetName: string
  dataName: string
  aggregate?: string[]
  head: IEditableTableHead[]
}

export interface IEditableData extends IData {
  [k: string]: {
    value: string | number
    unit?: string
    editable?: boolean
    editData?: {
      value: string | number
      unit?: string
    }
  }
}

export interface IEditableItem {
  id: string
  productName?: string
  custom?: boolean
  data?: IEditableData
}

interface IProps extends WithTranslation {
  config: IEditableTableConfig
  data: IEditableItem[]
  totalPrice?: number
  onAdd?: (item: IEditableItem) => void
  onChange?: (saveMode: SaveMode, item: IEditableItem) => void
}

interface IState {
  items: IEditableItem[]
  isAdding: boolean
}

class EditableTable extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)

    this.state = {
      items: props.data,
      isAdding: false,
    }
  }

  componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.data !== this.state.items) {
      this.setState({ items: nextProps.data })
    }
  }

  hasItems = () => this.state.items.length > 0

  startAdding = () => {
    this.setState({ isAdding: true })
  }

  cancelAdding = () => {
    this.setState({ isAdding: false })
  }

  // TODO: Implement API call to save new item
  handleAdd = (item: IEditableItem) => {
    const { items } = this.state
    const { onAdd } = this.props

    if (onAdd) {
      onAdd(item)
    }

    this.setState({
      isAdding: false,
      items: [...items, item as IEditableItem],
    })
  }

  handleSave = (saveMode: SaveMode, item: IEditableItem) => {
    const { items } = this.state
    const { onChange } = this.props

    const index = items.findIndex(i => i.id === item.id)

    // Did not find item
    if (index === -1) {
      console.error('Could not update item: Index does not exist')
    }

    if (onChange) {
      onChange(saveMode, item)
    }

    this.setState({
      items: [
        ...items.slice(0, index),
        Object.assign({}, items[index], item),
        ...items.slice(index + 1),
      ],
    })
  }

  getUnit = (key: string) => {
    const { head } = this.props.config
    const headItem = head.find((headItem: IEditableTableHead) => headItem.key === key)
    return headItem && headItem.unit ? headItem.unit : undefined
  }

  public render() {
    const { t, totalPrice } = this.props
    const { items, isAdding } = this.state
    const { dataSetName, head } = this.props.config

    const tableData = (
      <div>
        {this.hasItems() ? (
          items.map((elem: IEditableItem, index) => {
            return <EditableTableRow onSave={this.handleSave} item={elem} key={index} head={head} />
          })
        ) : (
          <div className={`flex py-10 border-gray-200 border-b-1`}>
            <p className={`w-full text-black text-13 font-400 tracking-0.1`}>
              Es sind keine {dataSetName} vorhanden.
            </p>
          </div>
        )}
      </div>
    )

    return (
      <>
        <div className="w-full mb-10 px-48">
          <Head head={head} />
          {tableData}
          {isAdding && (
            <ItemCreator
              head={head}
              onCancel={() => this.cancelAdding()}
              onAdd={data => this.handleAdd(data)}
            />
          )}
        </div>
        {!isNil(totalPrice) && (
          <TableResult
            config={tableResultConfig}
            data={[
              {
                desc: `${String(t('sum'))} ${dataSetName} ${String(t('total'))}`,
                totalPrice,
              },
            ]}
          />
        )}
        {/* {!isAdding && (
          <div className="px-48 mt-30">
            <Button onClick={() => this.startAdding()} primary>
              {`${dataName} ${t('add')}`}
            </Button>
          </div>
        )} */}
      </>
    )
  }
}

export default withTranslation()(EditableTable)
